import type {RouteParams} from 'types/routes'
import {MYPAGE_PATHS} from 'consts/paths'
import {StartChildcareFlow} from 'pages/withAuth/mypage/procedures/startChildcare/flow'

export const StartChildcareRoutes: RouteParams[] = [
  {
    key: '/mypage/start_childcare/flow/:id',
    path: MYPAGE_PATHS.PROCEDURES.START_CHILDCARE.FLOW,
    component: StartChildcareFlow,
    exact: true,
  },
]
